import createDuck, {createThunk} from '../utils/actions';
import axios from '../net/axios';
import config from '../config';
import {log} from '../utils/logs';

const baseUrl = config.api.baseUrl;

const produccionSelectorGetDuck = createDuck('PRODUCCION_SELECTOR_GET');

const produccionSelectorGetThunk = params => {
  const url = `${baseUrl}/v1/produccion/selector`;

  return createThunk(
    axios,
    'get',
    produccionSelectorGetDuck.actions,
    url,
    null,
    params,
  );
};

const produccionNotasGetDuck = createDuck('PRODUCCION_NOTAS_GET');

const produccionNotasGetThunk = params => {
  const url = `${baseUrl}/v1/produccion/selector/notas`;

  return createThunk(
    axios,
    'get',
    produccionNotasGetDuck.actions,
    url,
    null,
    params,
  );
};

const reportesEnviadosGetDuck = createDuck('REPORTES_ENVIADOS_GET');
const reportesEnviadosGetThunk = params => {
  const url = `${baseUrl}/v1/produccion/enviados`;

  return createThunk(
    axios,
    'get',
    reportesEnviadosGetDuck.actions,
    url,
    null,
    params,
  );
};

const enviarReporteDuck = createDuck('ENVIAR_REPORTE');
const enviarReporteThunk = params => {
  const url = `${baseUrl}/v1/produccion/enviar/manual`;

  return createThunk(
    axios,
    'get',
    enviarReporteDuck.actions,
    url,
    null,
    params,
  );
};

export {
  produccionSelectorGetDuck,
  produccionSelectorGetThunk,
  produccionNotasGetDuck,
  produccionNotasGetThunk,
  reportesEnviadosGetDuck,
  reportesEnviadosGetThunk,
  enviarReporteDuck,
  enviarReporteThunk,
};
